<template>
	<modal
		:title="title"
		:active="active"
		:dismissable="true"
		@dismiss="dismiss"
	>

		<modal-body>
			<p v-if="canDelete">
				{{ user.firstName }} will no longer be able to access the PioneerRx Ops Portal.
			</p>
            <p v-else>
                To delete {{ user.firstName }}, you must be a Group Admin in every group {{ user.firstName }} belongs to.
            </p>
		</modal-body>

		<modal-actions v-if="canDelete">
			<btn primary @click="onDelete">Delete</btn>
			<btn link @click="cancel">Cancel</btn>
		</modal-actions>
        <modal-actions v-else>
			<btn primary @click="close">Close</btn>
		</modal-actions>
		
	</modal>
</template>


<script>
    import { ModalMixin } from 'pdk/mixins';
    import { users } from '@/services';
    import { getters } from '@/store';
	

	export default {
		name: 'delete-user-modal',
		mixins: [ModalMixin],
		props: {
			user: Object,
        },
        data() {
            return {
                canDelete: false
            };
        },
		computed: {
			title() {
                return this.canDelete
                    ? `Delete ${this.user.firstName} ${this.user.lastName}?`
                    : `Unable to delete ${this.user.firstName} ${this.user.lastName}`;
            },
            isMe() {
                return this.$auth.tokenParsed.GlobalUserId == this.user.globalUserID;
            }
		},
        methods: {
            authorize() {
                return new Promise((resolve, reject) => {
                    const vm = this;
                    const user = vm.user;

                    if (vm.isMe) {
                        reject('You do not have permission to delete yourself');
                        return;
                    }

                    users.verifyDeleteUserPermission({
                        globalUserID: user.globalUserID
                    }).then((allowed) => {
                        vm.canDelete = allowed;
                        resolve(allowed);
                    })
                    .catch((response) => {
                        reject(response);
                    });
                });
            },
            onDelete() {
                if (!this.canDelete) return;

				this.$emit('delete');
			}
		}
	};
</script>
